import axios from 'axios';
import { CREATE_ACCOUNT_ESCROW_ENDPOINT, CREATE_ACCOUNT_ENDPOINT } from '../components/constants/endpoints';
import { appendTokenToUrl } from '../components/context/Recaptcha';

const { config } = window.appAirDrop;
const { additionalHeaders, loginRootUrl } = config;

const ESCROW_URL = `${loginRootUrl}${CREATE_ACCOUNT_ESCROW_ENDPOINT}`;
const CREATE_ACCOUNT_URL = `${loginRootUrl}${CREATE_ACCOUNT_ENDPOINT}`;

export async function getCreateAccountEscrow() {
  const response = await axios.get(ESCROW_URL, {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      Pragma: 'no-cache',
    },
  });

  return response.data?.data.createAccountEscrow;
}

export async function postCreateAccount(createAccountData: any, escrow: string, recaptchaToken?: string) {
  const linkAccountsEscrow = config?.PI_SESSION?.linkAccounts_escrow;
  let createAccountURL = `${CREATE_ACCOUNT_URL}/${escrow}`;
  if (linkAccountsEscrow) {
    createAccountURL = `${CREATE_ACCOUNT_URL}/${escrow}?linkAccounts_escrow=${linkAccountsEscrow}`;
  }
  const response = await axios.post(appendTokenToUrl(createAccountURL, recaptchaToken), createAccountData, {
    headers: {
      ...(additionalHeaders ?? {}),
      'Content-Type': 'application/json;charset=UTF-8',
    },
    withCredentials: true,
  });

  return response;
}
